import { Permisos } from '@/shared/constants/permisos';
import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const tourSeguridadSmtp: TourDefinicion = {
  codigo: 'seguridad-smtp',
  titulo: 'SMTP',
  descripcion: 'Servidores SMTP que usa cada aplicación para enviar correos.',
  ruta: '/admin/seguridad/smtp',
  permisoMenu: Permisos.SMTP_MENU,
  pasos: [
    {
      id: 'seguridad-smtp:header',
      selector: '[data-testid="seguridad-smtp.header"]',
      titulo: 'Configuración SMTP',
      descripcion:
        'Cada aplicación puede tener su propio servidor SMTP para envíos. Las credenciales se cifran en reposo.',
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'seguridad-smtp:boton-crear',
      selector: '[data-testid="seguridad-smtp.boton-crear"]',
      titulo: 'Nueva configuración',
      descripcion:
        'Registra host, puerto, usuario y contraseña para la aplicación que selecciones. Se prueba al guardar.',
      permisoRequerido: Permisos.SMTP_CREAR,
      side: 'left',
      align: 'center',
    },
    {
      id: 'seguridad-smtp:tabla',
      selector: '[data-testid="seguridad-smtp.tabla"]',
      titulo: 'Listado',
      descripcion: 'Edita o elimina cada configuración desde las acciones de la fila.',
      side: 'top',
      align: 'center',
    },
  ],
};
